import { render, staticRenderFns } from "./PatientsFormFollowup.vue?vue&type=template&id=75b9379a&scoped=true&"
import script from "./PatientsFormFollowup.vue?vue&type=script&lang=js&"
export * from "./PatientsFormFollowup.vue?vue&type=script&lang=js&"
import style0 from "./PatientsFormFollowup.vue?vue&type=style&index=0&id=75b9379a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b9379a",
  null
  
)

export default component.exports